import React from "react";

import SupportEscalationScreen from "@/b2b/components/SupportEscalationScreen";

/**
 * Shown when the tenant's bank account holder name did not match their PAN name on every allowed
 * penny-drop attempt (bureau-only path). The server has already FAILED the PENNY_DROP step and
 * marked the lead ineligible, and pre-flight answers `sorryReason: "account-name"` so a refresh
 * or resume lands back here.
 *
 * No `action` (no "Try again") on purpose: after the cap there is nothing the tenant can retry —
 * ops re-open the penny drop from cpbase if the mismatch was a false one. The copy never
 * promises Call / WhatsApp buttons: SupportContactActions hides them for some partners (KOTS),
 * so the screen would otherwise point at buttons that are not there. The Call / WhatsApp
 * buttons come from SupportEscalationScreen itself, which also escalates to ops on mount.
 */
export default function PennyDropSorryScreen({ theme }) {
  return (
    <SupportEscalationScreen
      theme={theme}
      topic="penny-drop-name-mismatch"
      reason="Bank account holder name did not match the PAN name after 3 attempts (bureau-only path)"
      problemLine="The bank account I entered is not accepted because the name does not match my PAN."
      copy={{
        idle: { title: "Please wait", body: "We are checking your details." },
        sent: {
          title: "We could not verify your bank account",
          body: "The account you entered is not in your name, so we could not continue. Our team has been notified and will reach out to you.",
        },
        failed: {
          title: "We could not verify your bank account",
          body: "The account you entered is not in your name, so we could not continue. Please reach out to our support team.",
        },
      }}
    />
  );
}
